import { connect } from 'react-redux'

import RepSelectContainer from './component'
import * as UserSelectors from 'app/modules/user/selectors'

const mapStateToProps = state => ({
  options: UserSelectors.nonBotOrgUsersAlphabetical(state)
})

export default connect(mapStateToProps)(RepSelectContainer)



// WEBPACK FOOTER //
// ./src/scripts/components/playbook/components/TargetingDisplay/RepSelectContainer/index.js